<template>
  <div>
    <div :class="{ 'aside lg:block': projectView }" class="relative gallery-height flex items-center">
      <template v-for="(slide, i) in images">
        <transition name="custom-classes-transition"
          :enter-active-class="animIn"
          :leave-active-class="animOut">
          <div v-show="visible(i)" @pointerdown="advance" :class="{ 'cursor-s-resize': projectView }" class="flex justify-around items-center slide">
            <slide :data="slide" :preload="preloadFirst(i)" :no-caption="noCaption" @advance="next" @retreat="previous"></slide>
          </div>
        </transition>
      </template>

      <nav v-if="hasNext && showNav" class="hide fixed right-0 bottom-0 mr1 no-select">
        <a class="py2 px1 inline-block pointer" @click="previous">
          <img src="~../assets/larr.svg" width="21" class="arr"/>
        </a>
        <a class="py2 px1 inline-block pointer" @click="next">
          <img src="~../assets/rarr.svg" width="21" class="arr"/>
        </a>
      </nav>


      <div v-if="hasNext && !projectView" @click="previous" class="z2 large-slide-nav absolute no-select left-0 top-0 bottom-0 cursor-left xs-hide"></div>
      <div v-if="hasNext && !projectView" @click="next" class="z2 large-slide-nav absolute no-select right-0 top-0 bottom-0 cursor-right xs-hide"></div>
    </div>

    <div v-if="images.length > 1 && projectView && !top" @click="scrollUp" class="hidden lg:block fixed top-0 right-0 project-prev cursor-n-resize"></div>
  </div>
</template>

<script>
  import debounce from 'debounce'
  import Slide from '@/components/partials/Slide'

  export default {
    name: 'gallery',
    data () {
      return {
        idx: 0,
        forward: true,
        firstLoad: true,
        top: true
      }
    },
    props: {
      data: Array,
      projectView: Boolean,
      noCaption: Boolean,
      preload: {
        type: Boolean,
        default: false
      },
      showNav: {
        type: Boolean,
        default: true
      }
    },
    computed: {
      slides () {
        return this.data ||
          this.$store.state.currentProject.acf.slides || []
      },
      images () {
        return this.slides.filter(i => i.acf_fc_layout === 'image')
      },
      hasNext () {
        return this.images.length > 1
      },
      current () {
        return this.images[this.idx]
      },
      last () {
        return this.images.length - 1
      },
      animIn () {
        return !this.firstLoad &&
          this.forward ? 'animated fadeInRight' : 'animated fadeInLeft'
      },
      animOut () {
        return !this.firstLoad &&
          this.forward ? 'animated fadeOutLeft' : 'animated fadeOutRight'
      }
    },
    methods: {
      visible (idx) {
        if (this.projectView) {
          let match = window.matchMedia('(min-width: 64em)').matches
          if (match) {
            return true
          }
        }
        return idx === this.idx
      },
      next () {
        this.forward = true
        this.$nextTick(() => {
          if (this.idx < this.last) this.idx++
          else this.idx = 0
        })
      },
      previous () {
        this.forward = false
        this.$nextTick(() => {
          if (this.idx > 0) this.idx--
          else this.idx = this.last
        })
      },
      refresh () {
        this.$forceUpdate()
      },
      preloadFirst (idx) {
        return this.preload && idx === 0
      },
      advance (e) {
        // console.log(e)
        if (e && e.pointerType === 'touch') return
        if (!this.projectView) return

        const slide = e.currentTarget
        let end = 0
        if (slide.nextElementSibling.classList.contains('slide')) {
          end = slide.nextElementSibling.getBoundingClientRect().top +
            window.pageYOffset
        }

        const duration = 450
        const clock = Date.now()

        const requestAnimationFrame = window.requestAnimationFrame ||
          window.mozRequestAnimationFrame || window.webkitRequestAnimationFrame ||
          function (fn) { window.setTimeout(fn, 15) }

        const step = () => {
          const elapsed = Date.now() - clock
          let position = end
          if (elapsed < duration) {
            position = window.pageYOffset + (end - window.pageYOffset) * easeInOutCubic(elapsed / duration)
            requestAnimationFrame(step)
          }
          window.scroll(0, position)
        }
        step()
      },
      scrollUp () {
        if (!this.projectView) return
        // find slide that is in view
        const slides = document.querySelectorAll('.slide')
        if (!slides) return
        let slide = null
        for (let i = 0; i < slides.length; i++) {
          const rect = slides[i].getBoundingClientRect()
          if ((rect.top >= 0 && rect.top <= window.innerHeight / 2) ||
            (rect.bottom <= window.innerHeight && rect.bottom >= window.innerHeight / 2)) {
            slide = slides[i]
            break
          }
        }
        if (!slide) return

        let end = 0
        if (slide.previousElementSibling) {
          end = slide.previousElementSibling.getBoundingClientRect().top +
            window.pageYOffset
        }

        const duration = 450
        const clock = Date.now()

        const requestAnimationFrame = window.requestAnimationFrame ||
          window.mozRequestAnimationFrame || window.webkitRequestAnimationFrame ||
          function (fn) { window.setTimeout(fn, 15) }

        const step = () => {
          const elapsed = Date.now() - clock
          let position = end
          if (elapsed < duration) {
            position = window.pageYOffset + (end - window.pageYOffset) * easeInOutCubic(elapsed / duration)
            requestAnimationFrame(step)
          }
          window.scroll(0, position)
        }
        step()
      },
      listen () {},
      onScroll () {
        this.top = window.scrollY < window.innerHeight / 2
      }
    },
    watch: {
      slides (newVal) {
        this.firstLoad = true
        this.$nextTick(() => {
          this.idx = 0
          this.firstLoad = false
        })
      }
    },
    mounted () {
      this.listen = debounce(this.refresh, 100)
      window.addEventListener('resize', this.listen)
      this.$nextTick(() => {
        this.firstLoad = false
      })
      window.addEventListener('scroll', this.onScroll)
    },
    destroyed () {
      window.removeEventListener('resize', this.listen)
      window.removeEventListener('scroll', this.onScroll)
    },
    components: { Slide }
  }

  function easeInOutCubic (t) {
    return t < 0.5
      ? 2 * t * t * t
      : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1
  }
</script>



// WEBPACK FOOTER //
// src/components/Gallery.vue